import { Box } from "@mui/material";
import { ErrorInfo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorCodes } from "@constants/ErrorCodes";
import CustomError from "@interfaces/CustomError";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { AxiosError } from "axios";

interface MyComponentProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
    componentName?: string,
}

const CustomErrorBoundary: React.FC<MyComponentProps> = ({ children, fallback, componentName }) => {

    const appInsights = useAppInsightsContext();

    function Fallback() {
        if (fallback != null)
            return fallback
        return (
            <Box role="alert">
                <p>Something went wrong!</p>
            </Box>
        );
    }

    const logError = (error: any, info: ErrorInfo) => {

        //Extract component name
        if (componentName == null) {
            const componentStack = info.componentStack as string;
            const componentNameRegex = /at (.*?)( |\(|\n)/;
            const match = componentNameRegex.exec(componentStack);
            componentName = match ? match[1] : 'Unknown Component';
        }
        const axiosError = error as AxiosError;
        let customError: CustomError = {
            message: error?.message,
            stack: info,
            errorCode: ErrorCodes.ERROR_BOUNDARY_FAILURE,
            statusCode: axiosError?.status,
            componentName: componentName,
            correlationId: axiosError?.config?.headers["X-CORRELATION-ID"],
            xUserId: axiosError?.config?.headers["X-User-ID"],
            metaDataId: 0
        };

        appInsights.trackException({
            severityLevel: SeverityLevel.Error,
            properties: { ...customError }
        });
    };

    return (
        <ErrorBoundary
            FallbackComponent={Fallback}
            onError={logError}
        >
            {children}
        </ErrorBoundary>
    );
}

export default CustomErrorBoundary;